// extracted by mini-css-extract-plugin
module.exports = {"tabItem":"TabItem_tabItem__1G6Ql","tabButtonSelected":"TabItem_tabButtonSelected__3riGA"};